import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css"
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './helpers/config/queryClient';
import { Toaster } from 'react-hot-toast';
import { SocketProvider } from './helpers/socket/SocketProvider';
import { GoogleTranslateProvider } from './helpers/context/GoogleTranslateContext';
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleTranslateProvider>
    <QueryClientProvider client={queryClient}>
      <SocketProvider>
        <BrowserRouter>
          <Toaster />
          <App />
        </BrowserRouter>
      </SocketProvider>
    </QueryClientProvider>
  </GoogleTranslateProvider>
);

